export default __webpack_public_path__ + "assets/qatar-flag.png";